var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "si-widget si-common-widgets waf-match-info-v2" },
    [
      _c(
        "div",
        {
          staticClass: "si-masthead-container si-historic-event-cntnr",
          attrs: { itemscope: "", itemtype: "https://schema.org/NewsArticle" },
        },
        [
          _c("match-info-head", {
            attrs: {
              last_updated_label: _vm.translations.last_updated_label,
              pageUrl: _vm.getPageUrl(),
              pageHeadline: _vm.generateHeadline(),
              article_mt_content: _vm.formatDateString(
                _vm.story_updated_date,
                "article_content",
                true
              ),
              article_mt_meta: _vm.formatDateString(
                _vm.story_updated_date,
                "article_meta",
                true
              ),
              article_pt_meta: _vm.formatDateString(
                _vm.story_created_date,
                "article_meta",
                true
              ),
            },
          }),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.matchStories) } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }